import { nanoid } from 'nanoid/async'
import { carouselModal } from './carouselModal'
import { updateNodeConnections } from '../../functions/utils'

const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data

  if (instagram_bot_addon) {
    return false
  }

  const { value: carouselData } = await carouselModal(oldData, node)

  if (carouselData && Object.values(carouselData).length > 0) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, carouselData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}